import { colours, sizes } from '@qflow/theme'
import styled from 'styled-components'
import { UTILITIES } from 'portal/components/Utilities/common/constants'
import { icons } from 'portal/lib/primitives'

type UtilitySelectorProps = {
  selectedUtility: string
  onChange: (utility: string) => void
}

export function UtilitySelector({
  selectedUtility,
  onChange
}: UtilitySelectorProps) {
  return (
    <UtilitySelectorWrapper>
      <ToggleButtons>
        <ToggleButton
          className={
            selectedUtility === UTILITIES.WATER ? 'selected' : undefined
          }
          onClick={() => onChange(UTILITIES.WATER)}
        >
          <icons.Modules.Water size={sizes.SMALL_MEDIUM} />
          {UTILITIES.WATER}
        </ToggleButton>
        <ToggleButton
          className={
            selectedUtility === UTILITIES.ELECTRICITY ? 'selected' : undefined
          }
          onClick={() => onChange(UTILITIES.ELECTRICITY)}
        >
          <icons.Modules.Electricity size={sizes.SMALL_MEDIUM} />
          {UTILITIES.ELECTRICITY}
        </ToggleButton>
      </ToggleButtons>
    </UtilitySelectorWrapper>
  )
}

const UtilitySelectorWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.75rem;
`
const ToggleButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.25rem;
`
const ToggleButton = styled.button`
  display: flex;
  height: 2.25rem;
  padding: 0 0.625rem;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  gap: 0.25rem;
  background-color: transparent;
  color: ${colours.CORE_NAVY};
  border-radius: 5px;
  border-color: transparent;
  border-width: 0;

  &.selected {
    background-color: ${colours.CORE_NAVY};
    color: ${colours.WHITE};
  }
`
